module.exports = __webpack_public_path__ + "static/bg_chrome-2fd2f90757e06ffb8fca66f82d7d82b6.jpg";